import React from 'react'

import { Box, Skeleton } from '@mui/material'

import { borderRadiusDefault } from '../../../../themes/theme'
import {
  HEAD_LINE_HEIGHT,
  HEAD_NODE_OFFSET,
  ROW_BOTTOM_SPACING,
  ROW_COLLAPSED_HEIGHT,
  ROW_NODE_OFFSET,
  SPINE_CENTER,
  SPINE_COLOR,
  SPINE_COLUMN_GAP,
  SPINE_COLUMN_WIDTH,
  SPINE_DOT_SIZE,
  SPINE_LINE_LEFT,
  SPINE_NODE_SIZE,
  SPINE_STUB_WIDTH,
} from '../helpers/liveEventEvolutionTimelineLayout'
import './LiveEventEvolutionTimeline.scss'

const SKELETON_ROWS = 5

/** Loading shape of the branching spine: same spine geometry, one rounded bar per row. */
export const LiveEventEvolutionTimelineSkeleton: React.FC = () => {
  return (
    <Box className="LiveEventEvolutionTimeline LiveEventEvolutionTimelineSkeleton">
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `${SPINE_COLUMN_WIDTH}px 1fr`,
          columnGap: SPINE_COLUMN_GAP,
          alignItems: 'stretch',
        }}
      >
        <Box sx={{ position: 'relative', minHeight: `${HEAD_LINE_HEIGHT}px` }}>
          <Box
            sx={{ position: 'absolute', left: `${SPINE_LINE_LEFT}px`, top: `${HEAD_NODE_OFFSET}px`, bottom: 0, width: '2px', backgroundColor: SPINE_COLOR }}
          />
          <Skeleton
            variant="circular"
            width={SPINE_NODE_SIZE}
            height={SPINE_NODE_SIZE}
            sx={{ position: 'absolute', left: `${SPINE_CENTER - SPINE_NODE_SIZE / 2}px`, top: `${HEAD_NODE_OFFSET - SPINE_NODE_SIZE / 2}px` }}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', minHeight: `${HEAD_LINE_HEIGHT}px`, mb: ROW_BOTTOM_SPACING }}>
          <Skeleton variant="text" width={220} height={16} />
        </Box>
      </Box>

      {Array.from({ length: SKELETON_ROWS }).map((_, index) => (
        <Box
          key={`skeleton-${index}`}
          sx={{
            display: 'grid',
            gridTemplateColumns: `${SPINE_COLUMN_WIDTH}px 1fr`,
            columnGap: SPINE_COLUMN_GAP,
            alignItems: 'stretch',
          }}
        >
          <Box sx={{ position: 'relative' }}>
            <Box sx={{ position: 'absolute', left: `${SPINE_LINE_LEFT}px`, top: 0, bottom: 0, width: '2px', backgroundColor: SPINE_COLOR }} />
            <Box
              sx={{
                position: 'absolute',
                left: `${SPINE_CENTER}px`,
                top: `${ROW_NODE_OFFSET}px`,
                width: `${SPINE_STUB_WIDTH}px`,
                height: '2px',
                backgroundColor: SPINE_COLOR,
              }}
            />
            <Skeleton
              variant="circular"
              width={SPINE_DOT_SIZE}
              height={SPINE_DOT_SIZE}
              sx={{
                position: 'absolute',
                left: `${SPINE_CENTER + SPINE_STUB_WIDTH}px`,
                top: `${ROW_NODE_OFFSET + 1}px`,
                transform: 'translate(-50%, -50%)',
              }}
            />
          </Box>
          <Skeleton variant="rounded" height={ROW_COLLAPSED_HEIGHT} sx={{ borderRadius: borderRadiusDefault, mb: ROW_BOTTOM_SPACING }} />
        </Box>
      ))}
    </Box>
  )
}

export default LiveEventEvolutionTimelineSkeleton
